function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("rect", {
  x: 22.0292,
  y: 149.5746,
  width: 43.1491,
  height: 86.2982,
  rx: 7.1915
});

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  x: 78.2934,
  y: 106.4254,
  width: 43.1491,
  height: 129.4473,
  rx: 7.1915
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 134.5576,
  y: 63.2764,
  width: 43.149,
  height: 172.5963,
  rx: 7.1915
});

var _ref5 =
/*#__PURE__*/
React.createElement("rect", {
  x: 190.8217,
  y: 20.1273,
  width: 43.149,
  height: 215.7454,
  rx: 7.1915
});

var SvgWebappIconOnlineLightTheme = function SvgWebappIconOnlineLightTheme(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWebappIconOnlineLightTheme, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/webapp-icon-online-light-theme.4305d9c7.svg";
export { ForwardRef as ReactComponent };